import React from "react";
import { processImagePath } from "../../../../util/Functions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ProductUtil } from "../../../../util/Product.util";

export default function ProductAttributeVariationButton({ product, attribute, active, icon, image, color, type, layout, text, onClick, dataId, distance, selected }) {
	const classes = [
		"variation",
		active && 'active',
		icon && 'has-icon',
		image && 'has-image',
		color && 'has-swatch',
		selected && "current",
	].filter(v => v).join(' ');

	const [tooltipText, setTooltipText] = React.useState(null);
	const dataset = {
		"data-component": "ProductAttributeVariationButton",
		"data-id": dataId,
		"data-distance": distance,
		"data-layout": layout,
	}

	const onMouseOver = e => {
		if (distance > 1) {
			const variationItem = ProductUtil.GetPreloadedProduct(dataId);
			const messages = ProductUtil.GetDifferences(variationItem, product)
				.filter(field => attribute.reference !== field.reference)
				.map(field => {
					return `${field.label} 
					${field.prefix || ''}${product?.[field.reference]}${field.suffix || ''}`;
				});
			messages.length && setTooltipText(
				<span className="tooltip-text">
					<span className="strong">{variationItem?.[attribute.reference]
						&& ((attribute.prefix || '') + variationItem[attribute.reference] + (attribute.suffix || ''))
					}</span>
					<span>{variationItem?.[attribute.reference] ? 'n' : 'N'}ot available with</span>
					{messages.map(m => <span key={m} className="item strong">{m}</span>)}
				</span >
			);
		}
	}

	return (
		<span onMouseOver={onMouseOver} className="button-wrapper">
			<OverlayTrigger
				delay={{ show: 250, hide: 0 }}
				overlay={<Tooltip style={distance > 1 ? {} : { display: 'none' }} className="_boss tooltip-info invariation-tooltip">{tooltipText}</Tooltip>}
			>
				<button
					onClick={onClick}
					color={color}
					icon={icon}
					className={classes}
					onMouseOver={onMouseOver}
					{...dataset}
				>
					{
						color
						&& !image
						&& (<span className='indicator' style={{ backgroundColor: color }}></span>)
					}
					{
						image
						&& (<img src={processImagePath(image, 'mini')} alt={text} />)
					}
					{
						(type !== 'icon')
							? text
							: (text && (<img src={processImagePath(icon)} alt={text} />))
					}
					{(type === 'icon') && (<div className="label">{text}</div>)}
				</button >
			</OverlayTrigger>
		</span >
	);
}
